import { Component, OnInit } from '@angular/core';
import { GrantService } from '../_services/grant.service';
import { OrganizationService } from '../_services/organization.service';
import { StatusService } from '../_services/status.service';
import { GrantListItem } from '../_models/grant-list-item';
import { Organization } from '../_models/organization';
import { Status } from '../_models/status';
import { forEach } from "@angular/router/src/utils/collection";
import { AuthenticationService } from '../_services/authentication.service';

@Component({
  moduleId: module.id,
  templateUrl: 'grants-list.component.html',
  styleUrls: ['grants-list.component.css']
})

export class GrantsListComponent implements OnInit {

 organizations: Array<Organization>;
 statuses: Array<Status>;

  constructor(
    private authenticationService: AuthenticationService,
    private grantService: GrantService,
    private organizationService: OrganizationService,
    private statusService: StatusService
  ) {}

  public grants: GrantListItem[];
  public filteredGrants: GrantListItem[];
  public grantsOnPage: GrantListItem[];
  public sortedField: string;
  public pages: number[];
  public currentPage: number;
  private grantsPerPage: number = 20;
  selectedOrg: number =0;
  selectedStatus: number = 0;
  selectedOrgName: string = 'Filter by Organization';
  selectedStatusName: string = 'Filter by Status';

  private sortBy(fieldName: string, sortFunc: (a: GrantListItem, b: GrantListItem) => number){
    if(this.sortedField !== fieldName){
      this.sortedField = fieldName;
      this.filteredGrants.sort(sortFunc);
    } else {
      this.sortedField = fieldName + '-descending';
      this.filteredGrants.reverse();
    }
    this.setGrantsOnPage(this.currentPage);
  }

  public sortByTextField(fieldName: string) {
    this.sortBy(fieldName, (a, b) => a[fieldName].localeCompare(b[fieldName]));
  }

  public sortByNumericField(fieldName: string) {
    this.sortBy(fieldName, (a, b) => a[fieldName] - b[fieldName]);
  }

  public sortByDateField(fieldName: string) {
    var sortFunc = (a, b) => {
        var aDate: string = a[fieldName];
        var bDate: string = b[fieldName];

        //Null dates haven't happened yet so they are after any date that is defined
        if (!aDate) return -1;
        if (!bDate) return 1;

        return aDate.localeCompare(bDate);
      };

    this.sortBy(fieldName, sortFunc);
  }

  public filterGrants(searchTerm: string) {
    if (searchTerm && searchTerm.length && this.grants) {
      searchTerm = searchTerm.toLowerCase();
      this.filteredGrants = this.grants.filter((grant: GrantListItem) => {
        var createdate: string = grant.createdate ? (new Date(grant.createdate)).toLocaleDateString('en-us') : '';
        var updatedate: string = grant.updatedate ? (new Date(grant.updatedate)).toLocaleDateString('en-us') : '';

        return (grant.status_name && grant.status_name.toLowerCase().indexOf(searchTerm) !== -1) ||
          (grant.id && grant.id.toLowerCase().indexOf(searchTerm) !== -1) ||
          (grant.applicantkey && grant.applicantkey.toLowerCase().indexOf(searchTerm) !== -1) ||
          (grant.organization_name && grant.organization_name.toLowerCase().indexOf(searchTerm) !== -1) ||
          (grant.user_name && grant.user_name.toLowerCase().indexOf(searchTerm) !== -1) ||
          (createdate.toLowerCase().indexOf(searchTerm) !== -1) ||
          (updatedate.toLowerCase().indexOf(searchTerm) !== -1)

      });
    } else {
      this.filteredGrants = this.grants;
    }

    this.setGrantsOnPage(0);
    this.pages = Array.from(Array(Math.ceil(this.filteredGrants.length / this.grantsPerPage)).keys());
  }

  public setGrantsOnPage(page: number){
    if (page >= 0 && page < this.pages.length) {
      this.currentPage = page;
      var start: number = page * this.grantsPerPage;
      var end: number = start + this.grantsPerPage;
      this.grantsOnPage = this.filteredGrants.slice(start, end);
    }
  }

  filterByOrg(event: Event, id: number, name: string): void {
    event.preventDefault();
    this.selectedOrgName = name;
    this.selectedOrg = id;
  }

  filterByStatus(event: Event, id: number, name: string): void {
    event.preventDefault();
    this.selectedStatusName = name;
    this.selectedStatus = id;
  }

  public ngOnInit(): void {
    this.currentPage = 0;
    this.grantsOnPage = this.filteredGrants = this.grants = [];
    this.pages = [];

    this.grantService.getAll()
      .then((grants) => {
          this.filteredGrants = this.grants = grants;
          this.pages = Array.from(Array(Math.ceil(grants.length / this.grantsPerPage)).keys());
          this.setGrantsOnPage(this.currentPage);
      });

    this.organizationService.getAll()
      .then((orgs) => {
          this.organizations = orgs;
    });

    this.statusService.getAll()
      .then((stats) => {
          this.statuses = stats;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/grants-list/grants-list.component.ts